import { render } from "./servicecategory-add.vue?vue&type=template&id=3cc7d595&lang=html"
import script from "./servicecategory-add.vue?vue&type=script&lang=js"
export * from "./servicecategory-add.vue?vue&type=script&lang=js"

import "./servicecategory-add.vue?vue&type=style&index=0&id=3cc7d595&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__